import i18n from 'services/base/i18n';

export default {
  // Text describing the title of the page
  title: () => i18n.pgettext('Pages|Password Reset', 'Confirmation'),

  // An email placeholder that should not be shown to the user unless they do hacker-like things
  // This is purely for display, so security is no issue
  emailPlaceholder: () => 'an email address',

  // Text for email address
  requestedFor: (email: string) => i18n.sprintf(
    i18n.pgettext('Pages|Password Reset', 'You requested a password reset for %s.'),
    email,
  ),

  // Text for the confirmation message
  emailSent: () => i18n.pgettext('Pages|Password Reset', 'If a matching account was found, an email as sent to it to allow you to reset your password.'),

  // Text for continue button
  submit: () => i18n.pgettext('Pages|Password Reset', 'CONTINUE'),
};
